(() => {
 const modal = document.getElementById('BalanzGrindModal');
 if (!modal) return;
 let opener, previousOverflow;
 document.addEventListener('click', e => {
   const trigger = e.target.closest('[data-balanz-guide-open], a[href="#guia-molienda"]');
   if (!trigger) return;
   e.preventDefault();
   opener = trigger;
   // Close the navigation drawer before opening the guide.
   const drawer = trigger.closest('header-drawer');
   const details = drawer && drawer.querySelector('details[open]');
   if (details) { const toggle = details.querySelector('summary'); if (toggle) toggle.click(); }
   if (!modal.open) { previousOverflow = document.body.style.overflow; modal.showModal(); document.body.style.overflow = 'hidden'; }
   document.getElementById('BalanzGuideTitle').focus();
 });
 modal.querySelector('[data-balanz-guide-close]').addEventListener('click', () => modal.close());
 modal.addEventListener('click', e => { if(e.target === modal) { const r=modal.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) modal.close(); } });
 modal.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; if(opener && opener.isConnected) opener.focus(); });
 const update = () => document.querySelectorAll('variant-picker').forEach(picker => {
   const beans = [...picker.querySelectorAll('input:checked,select')].some(el => (el.tagName==='SELECT' ? el.selectedOptions[0]?.textContent : el.value)?.trim().toLowerCase() === 'en grano');
   let help = picker.querySelector('.balanz-beans-help');
   if (!help && beans) { help=document.createElement('p'); help.className='balanz-beans-help'; help.innerHTML='Para esta opción necesitas un molino. ¿No tienes? <a href="#guia-molienda" data-balanz-guide-open>Te ayudamos a elegir tu molienda.</a>'; picker.append(help); }
   if(help) help.hidden=!beans;
 });
 document.addEventListener('change', update);
 new MutationObserver(update).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
 update();
})();